import { useQuery } from 'react-query';
import { fetchTopRatedTv } from '../services/api';

export const useTopRatedTv = options => {
  return useQuery('topRatedTv', fetchTopRatedTv, options);
};
